import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PrescriptionService } from '../../services/prescription.service';
import { PackageType } from 'src/interfaces/package-type';
import { DosageType } from 'src/interfaces/dosage-type';
import { UntypedFormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export interface DialogData {
  dosageTypeId: string;
  medicineDosagePackageType: number[];
  medicineId: number;
}

@Component({
    selector: 'core-dosage-type-package-type-dialog',
    templateUrl: './dosage-type-package-type-dialog.component.html',
    styleUrls: ['./dosage-type-package-type-dialog.component.scss'],
    standalone: false
})
export class DosageTypePackageTypeDialogComponent implements OnInit {

  dosageTypeId: string;
  medicineDosagePackageType: number[];
  medicineId: number;
  allPackageTypes: PackageType[];
  dosageTypes: DosageType[];

  // Chips
  separatorKeysCodes: number[] = [ENTER, COMMA];
  packageTypesCtrl = new UntypedFormControl();
  filteredPackageTypes: Observable<PackageType[]>
  selectedPackageTypes: PackageType[] = [];

  @ViewChild('packageTypeInput') packageTypeInput: ElementRef<HTMLInputElement>;

  constructor(
    public dialogRef: MatDialogRef<DosageTypePackageTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private prescriptionService: PrescriptionService
  ) {

    this.medicineId = data.medicineId;
    this.filteredPackageTypes = this
      .packageTypesCtrl
      .valueChanges
      .pipe(
        startWith(null),
        map((filter: string | null) =>
          this._filterPackageTypes(filter))
      );

  }

  ngOnInit(): void {

    this
      .prescriptionService
      .getMedicineDosageTypes(this.medicineId)
      .subscribe(dosageTypes => {
        this.dosageTypes = dosageTypes;
      });

  }

  getPackageTypes(dosageTypeId: number) {
    this
      .prescriptionService
      .getPackageTypes(this.medicineId, dosageTypeId)
      .subscribe(packageTypes => {
        this.allPackageTypes = packageTypes;
      });
  }

  _filterPackageTypes(filter: string | null): PackageType[] {
    return filter ? this
      .allPackageTypes
      .filter(packageType => packageType
        .type
        .toLowerCase()
        .includes(filter.toLowerCase()))
      : [];
  }

  addPackageType(event: MatChipInputEvent) {
    // Does nothing we want user to explicitly select the package
    // because using strings is not accurate
  }

  selectPackageType(event: MatAutocompleteSelectedEvent) {
    this.selectedPackageTypes.push(event.option.value);
    this.packageTypeInput.nativeElement.value = '';
    this.packageTypesCtrl.setValue(null);
  }

  removePackageType(packageTypeId: number) {

    const packageType: PackageType | undefined = this
      .selectedPackageTypes
      .find(type => type.id === packageTypeId);

    if (packageType) {

      const packageTypeIndex = this.selectedPackageTypes.indexOf(packageType);
      if (packageTypeIndex >= 0)
        this.selectedPackageTypes.splice(packageTypeIndex, 1);

      const packageTypeIdIndex = this.medicineDosagePackageType.indexOf(packageTypeId);
      if (packageTypeIdIndex >= 0)
        this.selectedPackageTypes.splice(packageTypeIdIndex, 1);

    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
